module.exports = "# This is a demo message, replace me!\n\nI've left a surprise for you in the back of the drawer in the night stand. I hope it suits you!\n\n> \"You know you're in love when you can't fall asleep because reality is finally better than your dreams.\" - Dr. Seuss"


//////////////////
// WEBPACK FOOTER
// ./src/examples/message.md
// module id = 100
// module chunks = 0